import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react";
import SocialMedias from "../../components/socialMedias/SocialMedias";
import { footerData } from "../../utils/footerData";
import classes from "./Footer.module.css";
import logo from "../navbar/main-logo.svg";
import logoEng from "../navbar/logo eng.svg";
import logoRu from "../navbar/logo rus.svg";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const [locationName, setLocationName] = useState("");
  const location = useLocation();

  const getLogo = () => {
    switch (i18n.language) {
      case "en":
        return logoEng;
      case "ru":
        return logoRu;
      default:
        return logo;
    }
  };

  useEffect(() => {
    if (location.hash === `#${locationName}`) {
      const openerElement = document.getElementById(locationName);
      openerElement.scrollIntoView({ behavior: "smooth" });
    }
  }, [locationName]);

  return (
    <div className={classes["footer-wrapper"]}>
      <div className={classes["footer"]}>
        <div className={classes["footer-section"]}>
          <Link to="/" className={classes["footer-logo-container"]}>
            <img className={classes["footer-logo"]} src={getLogo()} alt="logo" />
            <h2 className={classes["footer-logo-text"]}>
              {t("universityName").split("|").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  {index < t("universityName").split("|").length - 1 && <br />}
                </React.Fragment>
              ))}
            </h2>
          </Link>
          <p className={classes["footer-description"]}>
            {t("footerAddress")}
          </p>
          <SocialMedias />
          <p className={classes["footer-description"]}>
            {t("«Renessans universiteti» Barcha huquqlar himoyalangan")}
            <br />
            {t("Copyright")}-{new Date().getFullYear()}
          </p>
        </div>
        {footerData.map((section) => {
          return (
            <div key={section?.id} className={classes["footer-section"]}>
              <p className={classes["section-title"]}>
                {t(`footer_${section.title.toLowerCase()}`)}
              </p>
              {section.items.map((item) => {
                if (item.isExternal) {
                  return (
                    <a
                      key={item?.id}
                      href={item.path}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={classes["section-subtitle"]}
                    >
                      {t(`footer_${item.title.toLowerCase()}`)}
                    </a>
                  );
                }
                return (
                  <Link
                    key={item?.id}
                    onClick={() => setLocationName(item.path)}
                    to={
                      item.isSection
                        ? `/${item?.parentPath}${item?.path}`
                        : `/${item?.path}`
                    }
                    className={classes["section-subtitle"]}
                  >
                    {t(`footer_${item.title.toLowerCase()}`)}
                  </Link>
                );
              })}
            </div>
          );
        })}
        <div className={classes["footer-section"]}>
          <p className={classes["footer-title"]}>{t("footer_subscribe")}</p>
          <p className={classes["footer-description"]}>
            {t("footer_followNews")}
          </p>
          <div className={classes["input-wrapper"]}>
            <input className={classes["footer-input"]} type="text" />
            <div className={classes["icon-wrapper"]}>
              <Icon
                className={classes["send-icon"]}
                icon="mingcute:send-fill"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
